/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.phone-badge-check\":\"Smartphone and a badge with a check mark\"}");